import React from 'react';
import useGetFileArchiveList from '../../Hooks/useGetFileArchiveList';
import { LinearProgress, Stack } from '@mui/material';
import FrameCard from 'Global/Components/CommonComponents/FrameCard/FrameCard';
import CardInfo from './components/CardInfo';

export default function FileArchiveList() {
  const fileAcrhiveList = useGetFileArchiveList();

  return (
    <>
      <Stack gap=".5em" marginBottom="1em">
        {fileAcrhiveList === null ? (
          <LinearProgress sx={{ mt: '.5em' }} />
        ) : (
          fileAcrhiveList.map((item) => (
            <FrameCard
              cardProps={{
                p: '.3em',
                borderRadius: '20px',
              }}
              jsx={<CardInfo item={item} />}
              key={item.Id}
            />
          ))
        )}
      </Stack>
    </>
  );
}
